import axios from "axios";

import { FETCH_ACCOUNTS } from "./type";

export const fetchAccount =
  ({ userId, bustCache }, callback) =>
  async (dispatch, getStore) => {
    // Add cache-busting query param if bustCache is true
    const cacheBuster = bustCache ? `?_t=${Date.now()}` : "";
    const {
      data: { accountMap }
    } = await axios.get(`account/${userId}${cacheBuster}`);

    dispatch({ type: FETCH_ACCOUNTS, payload: { accountMap } }); // get teacher access

    if (callback) callback();
  };
